import React from 'react';

const FilterSorterSkeleton: React.FC = () => {
    return (
        <div className="flex items-center justify-end gap-3 relative animate-pulse">
            <div className="flex items-center gap-[5px] px-3 py-2 rounded-[4px] bg-gray-200">
                <div className="w-[15px] h-[15px] bg-gray-300 rounded"></div>
                <div className="h-4 bg-gray-300 rounded w-20"></div>
            </div>

            <div className="flex items-center gap-[5px] px-[12px] py-[8px] rounded-[4px] bg-gray-200">
                <div className="w-[15px] h-[15px] bg-gray-300 rounded"></div>
                <div className="h-4 bg-gray-300 rounded w-16"></div>
            </div>
        </div>
    );
};

export default FilterSorterSkeleton;
